export default __webpack_public_path__ + "static/media/hibobi.606b120d.png";